import { ModalContext } from 'app/app';
import { useNavigate } from 'components/lib';
import { Fragment, useContext, useEffect, useState } from 'react';
import image from '../RunQuoteModal/images/loader.gif';
import styles from './styles.module.scss';

const QUOTE_TYPES = [{ value: 'personal_auto', label: 'Personal Auto' }];

export function RunPersonalQuoteModal() {
  const { modal, setModal } = useContext(ModalContext);
  const [loading, setLoading] = useState(false);
  const [selectedType, setSelectedType] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    if (modal.name !== 'run_personal_quote_modal') {
      setSelectedType('');
    }
  }, [modal.name]);

  const handleRun = async () => {
    if (!selectedType) return;
    setLoading(true);

    navigate('/app/quote/individual', {
      state: {
        data: {
          quoteType: selectedType,
        },
      },
    });

    setLoading(false);
    setModal({});
    setSelectedType('');
  };

  return (
    <Fragment>
      {modal.name === 'run_personal_quote_modal' && (
        <div className={styles.background}>
          <div className={styles.wrapper}>
            <div className={styles.insideWrapper}>
              <div className={styles.title}>Run Personal Quote</div>
              <div className={styles.line} />
              <div className={styles.form}>
                <div className={styles.optionList}>
                  {QUOTE_TYPES.map((opt) => {
                    const checked = selectedType === opt.value;
                    return (
                      <label key={opt.value} className={styles.optionRow}>
                        <input
                          type="checkbox"
                          checked={checked}
                          onChange={() =>
                            setSelectedType(checked ? '' : opt.value)
                          }
                        />
                        <span>{opt.label}</span>
                      </label>
                    );
                  })}
                </div>
              </div>

              <div className={styles.footer}>
                <div className={styles.buttons}>
                  <button
                    className={styles.cancel}
                    onClick={() => setModal('')}
                    type="button"
                  >
                    Cancel
                  </button>
                  <button
                    className={styles.save}
                    style={
                      !loading && selectedType
                        ? { cursor: 'pointer' }
                        : { cursor: 'not-allowed', opacity: 0.7 }
                    }
                    disabled={!selectedType || loading}
                    type="button"
                    onClick={handleRun}
                  >
                    {loading ? (
                      <img src={image} alt="loading" className={styles.loader} />
                    ) : (
                      'Run'
                    )}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </Fragment>
  );
}
